import { getCookie } from "./actions/auth";

export const config = () => ({
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
    Authorization: "JWT " + getCookie("token"),
  },
});
